import React, {Component, Fragment} from 'react';
import {Redirect} from 'react-router-dom';
import PagingRouter from '../common/PagingRouter';
import getPeriodAnchor from '../../utils/getPeriodAnchor';
import {Mutation, Query} from 'react-apollo';
import Loading from '../settings/Loading';
import Error from '../settings/Error';
import favoritePageQuery from './favoritePageQuery';
import {ReportsResult} from '../reports/ReportsResultPage';
import SettingsTabBar from '../settings/SettingsTabBar';
import removeFavoriteMutation from './removeFavoriteMutation';
import ReportCardGrid from '../common/card-grid/ReportCardGrid';
import Info from '../common/card-grid/Info';
import Settings from '../settings/Settings';
import queryString from 'query-string';
import {QUERY_KEY_SETTINGS} from '../settings/types';
import ConfirmModal from '../app/ConfirmModal';

class FavoritesResult extends Component {
  constructor(props) {
    super(props);
    this.state = {modalConfirmAction: null};
  }
  setActive = i => this.props.history.push(this.props.getPageUrl(i));

  render() {
    const {match, location, getPageUrl, favorites, removeFavoriteFromCache} = this.props;
    const {page} = match.params;
    const active = page && parseInt(page, 10);
    const isActive = typeof active !== 'undefined';
    const {search, pathname} = location;
    const query = queryString.parse(search);
    const settingsType = query[QUERY_KEY_SETTINGS];
    if (active > favorites.length - 1 || Number.isNaN(active) || (!isActive && settingsType))
      return <Redirect to={getPageUrl()} />;
    if (!isActive && favorites.length === 1) return <Redirect to={getPageUrl(0)} />;
    return (
      <Fragment>
        {isActive && (
          <SettingsTabBar
            type={settingsType}
            toggleSettings={type => {
              const newSettingsType = type === settingsType ? undefined : type;
              const newQuery = {...query, [QUERY_KEY_SETTINGS]: newSettingsType};
              this.props.history.push({
                pathname,
                search: queryString.stringify(newQuery),
              });
            }}
            settings={favorites[active].report.settings}
          />
        )}
        {settingsType ? (
          <Settings {...this.props} favoriteId={favorites[active].id} type={settingsType} />
        ) : (
          <Mutation mutation={removeFavoriteMutation} update={removeFavoriteFromCache}>
            {(removeFavorite, {loading /*, error // Todo: show error*/}) =>
              loading ? (
                <Loading />
              ) : (
                <ReportsResult
                  {...this.props}
                  reports={favorites.map(({report}) => report)}
                  active={active}
                  setActive={this.setActive}
                  isFavorite={true}
                  onFavoriteClick={(_, i) =>
                    this.setState({
                      modalConfirmAction: () => {
                        removeFavorite({variables: {input: {id: favorites[i].id}}});
                        this.setState({modalConfirmAction: null});
                      },
                    })
                  }
                />
              )
            }
          </Mutation>
        )}
        <ConfirmModal
          isVisible={this.state.modalConfirmAction !== null}
          confirm={this.state.modalConfirmAction}
          cancel={() => this.setState({modalConfirmAction: null})}
          question={'Favorit entfernen? Sind Sie sich sicher'}
        />
      </Fragment>
    );
  }
}

const PagedFavoritesResult = PagingRouter(FavoritesResult, undefined, true);

class FavoritesPage extends Component {
  getPeriodAnchor(page) {
    if (page !== this.page) {
      this.page = page;
      this.periodAnchor = getPeriodAnchor();
    }
    return this.periodAnchor;
  }

  render() {
    const {match, getPageUrl, history} = this.props;
    const pageNum = parseInt(match.params.page, 10);
    const variables = {
      input: {filter: {offset: pageNum, limit: 1}},
      reportInput: {periodAnchor: this.getPeriodAnchor(pageNum)},
    };
    return (
      <Query query={favoritePageQuery} variables={variables} fetchPolicy="network-only">
        {({loading, error, data, refetch}) => {
          console.log(data);
          if (loading) return <Loading />;
          if (error) return <Error error={error} />;
          const {pages, total, hasNextPage} = data.favoritePages;
          if (pageNum !== 0 && (!pages || !pages.length)) return <Redirect to={getPageUrl(0)} />;
          if (!total)
            return (
              <ReportCardGrid>
                {[
                  <Info key="info" onClick={() => history.push('/reports')}>
                    Favorisierte Auswertungen werden hier angezeigt.
                  </Info>,
                ]}
              </ReportCardGrid>
            );
          let removeFavoriteFromCache;
          let page;
          if (pages.length) {
            [page] = pages;
            removeFavoriteFromCache = (cache, result) => {
              const {id, pagesGotShifted, gotRemoved} = result.data.removeFavorite;
              if (!gotRemoved) return;
              const favorites = page.favorites.filter(fav => fav.id !== id);
              if (!favorites.length) {
                if (pagesGotShifted || pageNum === 0) {
                  refetch();
                } else {
                  history.push(getPageUrl(0));
                }
                return;
              }
              cache.writeQuery({
                query: favoritePageQuery,
                variables,
                data: {
                  ...data,
                  favoritePages: {
                    ...data.favoritePages,
                    pages: [{...page, favorites}],
                  },
                },
              });
            };
          }
          return (
            <PagedFavoritesResult
              match={match}
              totalPages={total}
              page={pageNum}
              favorites={page ? page.favorites : []}
              removeFavoriteFromCache={removeFavoriteFromCache}
              hasNextPage={pageNum !== 0 || hasNextPage}
              showNextPage={() => history.push(getPageUrl(hasNextPage ? pageNum + 1 : 0))}
              showSettings
            />
          );
        }}
      </Query>
    );
  }
}

export default PagingRouter(FavoritesPage);
